import { generateID } from './PanelTemplatesTheme/helpers';
import { Panel } from '../../models/Panel/Panel';

export var TemplateHyperlinkButton: Panel = {
    id: 'hyperlink-button',
    name: 'Hyperlink Button',
    description: '',
    tags: ['blank', 'landscape', 'portrait', 'interstitial'],
    widget: {
        id: generateID(),
        classes: 'template_hyperlink_button',
        children: [
            {
                type: 'hyperlinkButton',
                id: 'hyperlink-button',
                name: 'Hyperlink Button',
                options: {
                    url: 'https://www.yourlink.com',
                    slideNumber: 1,
                    text: 'Click Here',
                    fontSize: 40,
                    buttonBorder: {
                        enabled: false,
                        radius: 15,
                    },
                    font: {},
                },
                position: {
                    grid: {
                        enabled: true,
                        columns: {
                            start: 3,
                            end: 9,
                        },
                        rows: {
                            start: 2,
                            end: 4,
                        },
                    },
                },
            },
        ],
    },
};
